// useEnterNavigation.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // For navigation

const UseEnterNavigation = (nextPath) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        var type = event.srcElement.type;
        if (type === "date" || type === "text" || type === "number") {
          const formElements = Array.from(
            document.querySelectorAll("input, select, textarea, button")
          );
          const currentIndex = formElements.indexOf(document.activeElement);

          if (
            formElements.length === 1 ||
            currentIndex === formElements.length - 1
          ) {
            event.preventDefault();

            if (nextPath) {
              navigate(nextPath);
            }
          } else if (
            currentIndex > -1 &&
            currentIndex < formElements.length - 1
          ) {
            event.preventDefault();
            formElements[currentIndex + 1].focus();
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [navigate, nextPath]);
};

export default UseEnterNavigation;
